import { CommunicationList } from 'civil-status/view-models/communication-from-list';
import { HeadCell } from 'shell/components/shared/table/types';

export const headCells: HeadCell<CommunicationList, keyof CommunicationList>[] = [
  {
    id: 'typeEvent',
    label: 'Registro',
  },
  {
    id: 'code',
    label: 'Codice comunicazione',
  },
  {
    id: 'holder',
    label: 'Intestatario',
  },
  {
    id: 'idAnsc',
    label: 'ID Ansc',
    colSpan: 2,
  },
  {
    id: 'dateAct',
    label: 'Data atto',
  },
  {
    id: 'datePrint',
    label: 'Data stampa',
  },
  {
    id: 'statePrint',
    label: 'Stato stampa',
  },
  {
    id: 'action',
    label: 'Azioni',
  },
];
